export default __webpack_public_path__ + "static/49-6b9e0d9932bf5e65b4f91c854b0be162.png";